import cleanProfile from './dryRunCleanProfile.json';

// Canned synthetic bench profiles. Every value is INVENTED — no real applicant record may be copied
// into an example — and every field name is a camelCase dot-path, the same shape a case's `profile`
// is evaluated against.
//
// Each scenario is the FULL clean profile plus its own overrides, never a handful of fields on their
// own: a computed rule reads an ABSENT field as zero, so a sparse profile silently fires rules
// ("letter is 0 characters", "$0/year") and can never express "no flags expected".
const withOverrides = (overrides: Record<string, unknown>): Record<string, unknown> => ({
  ...cleanProfile,
  ...overrides,
});

export interface DryRunSampleProfile {
  readonly id: string;
  readonly labelKey: string;
  readonly profile: Record<string, unknown>;
}

export const DRY_RUN_SAMPLE_PROFILES: DryRunSampleProfile[] = [
  {
    id: 'baseline',
    labelKey: 'rules.dryRun.sample.baseline',
    profile: withOverrides({}),
  },
  {
    id: 'governmentAssistance',
    labelKey: 'rules.dryRun.sample.governmentAssistance',
    profile: withOverrides({ isGovernmentAssistance: true, isFinanciallyStable: false }),
  },
];
